import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {Title} from '@angular/platform-browser';
import {ProduitDTO} from '../../core/dtos/produit-dto';
import {UtilsService} from '../../core/utils/utils.service';
import {GenericFormService} from '../../core/services/generics/generic-form.service';
import {ProduitsService, ProduitSupplier} from '../../core/services/entities/produits.service';
import {MenuItem} from 'primeng/api';
import {ItemNavigationService} from '../../core/services/technique/item-navigation.service';
import {TabMenu} from 'primeng/tabmenu';
import {Auth2Service} from "../../core/services/security/auth2.service";
import {CommunicationProduitService} from "../../core/services/entities/referentiel.base/communication-produit-service";

@Component({
  selector: 'yo-produit',
  templateUrl: './produit.component.html',
  styleUrls: ['./produit.component.scss']
})
export class ProduitComponent implements OnInit, OnDestroy {

  subscriptionRoute: Subscription;
  subDeletedProduitDeclinaison: Subscription;
  subActiveSecondaryRoute: Subscription;

  @ViewChild('tabMenu') tabMenu: TabMenu;

  produit: ProduitDTO;
  isFabrique: boolean;
  tabMenuProduit: MenuItem[] = [];
  activeTab: MenuItem;
  refresh = new Date().getTime();

  hasIDistri = false;

  hasCommunicationProduit = false;
  private isMeal: any;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private gfs: GenericFormService,
              private itemNavSvc: ItemNavigationService,
              private titleSvc: Title,
              public produitsSvc: ProduitsService,
              private cd: ChangeDetectorRef,
              private authSvc: Auth2Service,
              private utils: UtilsService,
              private communicationProduitSvc: CommunicationProduitService) {
  }

  ngOnInit() {
    this.initHasGestionIDistri();
    // Si pas de produit decli rattaché, on cache les onglets qui ont besoin des prdouits déclis
    this.deletedProduitDeclinaisonSubscription();

    // Chargement de la page, recup du produit à partir du resolver
    this.routeSubscription();

    this.activeSecondaryRouteSubscription();


  }

  initHasGestionIDistri = (): void => {
    this.authSvc.hasGestionIDistri$.subscribe(response => this.hasIDistri = response);
  };

  /**
   * Si pas de produit decli rattaché, on cache les onglets qui ont besoin des prdouits déclis
   */
  deletedProduitDeclinaisonSubscription = () => {
    this.subDeletedProduitDeclinaison = this.gfs.deletedId$.subscribe(response => {

      if (!this.utils.isNullOrEmpty(this.produit) && !this.utils.isCollectionNullOrEmpty(this.produit.produitDeclinaisons)) {
        let arrProduitDecli = this.produit.produitDeclinaisons.filter(item => item.id != response.one);
        if (this.utils.isCollectionNullOrEmpty(arrProduitDecli)) {
          this.produit.produitDeclinaisons = [];
          this.initTaMenuProduit();
        }
      }
    });
  };

  /**
   * Chargement de la page, recup du produit à partir du resolver
   */
  routeSubscription = () => {
    this.subscriptionRoute = this.route.data
      .subscribe((data: { produitSupplier: ProduitSupplier }) => {
        this.produit = data.produitSupplier.produitDTO;
        this.isFabrique = data.produitSupplier.isFabrique;
        this.titleSvc.setTitle(this.produit && this.produit.libelle);
        this.communicationProduitSvc.checkIfProduitHasCommunicationProduitValues(this.produit.id).subscribe(result => {
          this.hasCommunicationProduit = result;
          this.initTaMenuProduit();
          this.refresh = new Date().getTime();
          this.activeSecondaryRouteSubscription();
        });
        if (this.utils.isIdInit(this.produit.id)) {
          this.produitsSvc.getProduitById(this.produit.id).subscribe(response => {
            this.isMeal = response.meal;
            this.initTaMenuProduit();
          });
        }

      });
  };

  private initTaMenuProduit = () => {
    this.tabMenuProduit = [];

    this.tabMenuProduit.push({label: `Fiche d'identité`, routerLink: ['ficheidentite']});

    //Si le produit existe
    if (this.utils.isNumberGt0(this.produit.id)) {
      this.tabMenuProduit.push({label: `Déclinaisons`, routerLink: ['produit-declinaisons']});

      if (!this.utils.isCollectionNullOrEmpty(this.produit.produitDeclinaisons)) {

        this.tabMenuProduit.push({label: `Allergènes`, routerLink: ['allergenes']});
        this.tabMenuProduit.push({label: `Appellations`, routerLink: ['appellations']});
        this.tabMenuProduit.push({label: `Apports nutris`, routerLink: ['ciqual']});

        if (!this.isFabrique) {
          this.tabMenuProduit.push({label: `Articles`, routerLink: ['articles']});
          this.tabMenuProduit.push({label: `Marchés`, routerLink: ['marches']});
        }

        if (this.isFabrique) {
          this.tabMenuProduit.push({label: `Familles diététiques`, routerLink: ['gemrcn']});
          this.tabMenuProduit.push({label: `Fiche technique`, routerLink: ['fichetechnique']});
          this.tabMenuProduit.push({label: `Mode opératoire`, routerLink: ['mode-operatoire']});

          if (this.hasIDistri)
            this.tabMenuProduit.push({label: `Conditionnement`, routerLink: ['conditionnement']});
        }
      }
      if (this.hasCommunicationProduit)
        this.tabMenuProduit.push({label: `Communication`, routerLink: ['communication']})

      if (this.isMeal && this.produit.produitDeclinaisons.length > 0)
        this.tabMenuProduit.push({label: `Popularité`, routerLink: [`popularite`]})
    }

    const currentUrl = this.router.url;
    const matchingTab = this.tabMenuProduit.find(item => currentUrl.includes(item.routerLink[0]));

    if (matchingTab) {
      this.activeTab = matchingTab;
    } else if (!this.activeTab) {
      this.activeTab = this.tabMenuProduit[0];
    }

  };


  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subscriptionRoute);
    this.utils.unsubscribe(this.subDeletedProduitDeclinaison);
    this.utils.unsubscribe(this.subActiveSecondaryRoute);
  }

  libelleProduit = (produit: ProduitDTO): string => {
    let response = produit.libelle;
    return response;
  };


  activeSecondaryRouteSubscription = () => {
    this.subActiveSecondaryRoute = this.itemNavSvc.secondaryRoute$.subscribe(event => {
      this.activeTab = this.itemNavSvc.activeSecondaryRoute(event, this.tabMenuProduit);
    });

  };

}
